import { SxProps, Theme } from '@mui/material';
import { TEXT_SECONDARY } from '../../../styles/GlobalStyles';

export const reportPickerStyles = {
  description: (theme: Theme) => ({
    marginBottom: theme.spacing(1),
    color: TEXT_SECONDARY,
    fontSize: '18px',
    fontWeight: theme.typography.fontWeightRegular,
    flexShrink: 0,
  }) satisfies SxProps<Theme>,
  collectionFilter: {
    width: '260px',
    maxWidth: '100%',
    paddingTop: '8px',
    marginBottom: '20px',
  } satisfies SxProps<Theme>,
  emptyContainer: {
    position: 'relative',
    height: 'calc(100vh - 150px)',
  } satisfies SxProps<Theme>,

  emptyContent: {
    position: 'absolute',
    top: '30%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '654px',
    maxWidth: '100%',
    textAlign: 'center',
  } satisfies SxProps<Theme>,

  emptyImage: {
    maxWidth: '100%',
    height: 'auto',
  } satisfies SxProps<Theme>,

  emptyTabContent: {
    position: 'absolute',
    inset: 0,
    display: 'grid',
    gridTemplateRows: '45% auto 1fr',
    justifyItems: 'center',
    textAlign: 'center',
  } satisfies SxProps<Theme>,

  emptyTabImage: {
    alignSelf: 'center',
    maxHeight: '100%',
    objectFit: 'contain',
  } satisfies SxProps<Theme>,

  emptyTabMessage: {
    marginTop: '40px',
  } satisfies SxProps<Theme>,

  emptyMessage: {
    marginTop: '-25px',
    fontFamily: 'Handwritten, monospace',
    fontSize: '1.2em',
  } satisfies SxProps<Theme>,

  reportList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 150px)',
    gap: '30px',
    listStyle: 'none',
    margin: 0,
    padding: 0,
  } as SxProps<Theme>,

  reportButton: (theme: Theme) => ({
    width: '150px',
    minHeight: '140px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: 0,
    border: 0,
    color: '#333',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 'normal',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    // Override the legacy button:focus border without hiding keyboard focus.
    '&:focus': {
      border: '0 !important',
      outline: 'none !important',
    },
    '&.Mui-focusVisible': {
      outline: `2px solid ${theme.palette.primary.main} !important`,
      outlineOffset: '2px',
    },
  }) as SxProps<Theme>,

  thumbnailFrame: {
    position: 'relative',
    width: '150px',
    height: '140px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #DDDDDD',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.4)',
    boxSizing: 'border-box',
  } as SxProps<Theme>,

  thumbnail: {
    position: 'absolute',
    top: '15px',
    left: '15px',
    display: 'block',
    width: '120px',
    height: 'auto',
    maxHeight: '120px',
    objectFit: 'contain',
  } as SxProps<Theme>,

  container: (theme: Theme) =>
    ({
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      marginTop: '50px',
      padding: theme.spacing(2),
      boxSizing: 'border-box',
    }) satisfies SxProps<Theme>,

  tabbedContainer: {
    height: 'calc(100vh - 150px)',
    minHeight: 0,
    overflow: 'hidden',
  } satisfies SxProps<Theme>,

  tabPanel: {
    position: 'relative',
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '4px',
  } as SxProps<Theme>,

  tabs: (theme: Theme) =>
    ({
      minWidth: 0,
      flexShrink: 0,
      marginBottom: theme.spacing(2),
      borderBottom: 1,
      borderColor: 'divider',
    }) as SxProps<Theme>,

  tab: (theme: Theme) =>
    ({
      fontSize: '20px',
      fontWeight: theme.typography.fontWeightMedium,
      outline: 'none !important',
      boxShadow: 'none !important',
      border: 'none !important',
      '&:focus, &:active, &:focus-visible': {
        outline: 'none !important',
        boxShadow: 'none !important',
        border: 'none !important',
      },
      '&.Mui-focusVisible': {
        outline: `2px solid ${theme.palette.primary.main} !important`,
        outlineOffset: '-2px',
      },
    }) as SxProps<Theme>,
};
